import LoopIcon from '@mui/icons-material/Loop';
import MDBox from "../../components/MDBox";

export default function Loading({large}) {

  return (
    <div className={'loading mt-5'}>
      <MDBox className={'text-center'}>
        <span style={{
          fontSize: large ? '24px' : '14px'
        }}>
          <LoopIcon className="spin"/> Loading...
        </span>
      </MDBox>
    </div>
  );

}